import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgBusinessFilled = (props) => {
    const { color } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 4v2H4a2 2 0 0 0-2 2v1.122l9.633 3.807a1 1 0 0 0 .735 0L22 9.122V8a2 2 0 0 0-2-2h-3V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2Zm8 0H9v2h6V4Z", fill: color }),
        React.createElement("path", { d: "m22 11.273-8.897 3.516a3 3 0 0 1-2.205 0L2 11.273V18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6.727Z", fill: color })));
};
export default factorySvgIcon(SvgBusinessFilled);
//# sourceMappingURL=SvgBusinessFilled.js.map